export default class Plague {
    constructor({
        id = 0,
        name = '',
    } = {}) {
        this.id = id;
        this.name = name;
    }
}